import { redirectAliasedChatFeatureRoute } from '@/chat-common/conversation-navigation/util/redirect-aliased-chat-feature-route'
import type { RouteFactory } from '@/routing/types'
import ChatLayout from '@/routes/dashboard/ChatLayout'

/**
 * Creates chat routes for nesting under MatterLayout.
 * URL pattern: /dashboard/m/:matterId/chat/:chatFeature/:chatId?
 *
 * @see MatterLayout for parent route context
 */
export const createChatChildRoutes: RouteFactory = () => [
  {
    path: 'chat/:chatFeature',
    // Handles feature aliasing (e.g. drafting → assistant)
    loader: redirectAliasedChatFeatureRoute,
    children: [
      // Chat without chatId
      {
        index: true,
        element: <ChatLayout />,
      },
      // Chat with specific conversation
      {
        path: ':chatId',
        element: <ChatLayout />,
      },
    ],
  },
]
